import { defineComponent } from "vue";

var __default__ = defineComponent({
  name: "AnimatedPlaceHolder",
  props: {
    height: {
      type: String
    },
    width: {
      type: String
    },
    borderRadius: {
      type: String
    }
  }
});

import { useCssVars as _useCssVars } from 'vue';

var __injectCSSVars__ = function __injectCSSVars__() {
  _useCssVars(function (_ctx) {
    return {
      "24fcfbcb": _ctx.height,
      "b1a042bc": _ctx.width,
      "d99448fc": _ctx.borderRadius
    };
  });
};

var __setup__ = __default__.setup;
__default__.setup = __setup__ ? function (props, ctx) {
  __injectCSSVars__();

  return __setup__(props, ctx);
} : __injectCSSVars__;
export default __default__;